//
//
//
//
//
//
//
//
//
//
//
//
//
//

import QiniuImg from './QiniuImg.vue'

export default {
  name: 'CityTab',
  props: {
    cities: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    QiniuImg,
  },
  methods: {
    getAdUrl(ad) {
      if (ad.adType === 1) {
        return `/match/${ad.targetId}`
      } else if (ad.adType === 3) {
        return `/route/${ad.targetId}`
      } else if (ad.adType === 4) {
        return `/header/search?q=${ad.keyword}`
      } else if (ad.adType === 5) {
        return `/header/search?city=${ad.keyword}`
      }
      return ad.url
    },
  },
}



// WEBPACK FOOTER //
// ./client/components/Common/CityTab.vue